// extracted by mini-css-extract-plugin
module.exports = {"container":"Chat--ChatTextField-module_container-3hQb3","attach":"Chat--ChatTextField-module_attach-2YuOY","sendButton":"Chat--ChatTextField-module_sendButton-gseNv"};